export enum ContactListAction {
    Unsubscribe = "Unsubscribe",
    Delete = "Delete",
}

export interface UpdateContactListRequest {
    stockId: string;
    // undefined = the stock's default list
    listId?: string;
    action: ContactListAction;
    contacts: { email: string }[];
}

export interface UpdateContactListResult {
    errorMessage: string;
    notFound: string[];
}
